// ==============================|| PRESET THEME - ZOIDESQ BLUE ||============================== //

export default function Default(colors) {
  const { red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: '#E7F0FF',
      100: '#C2D8FF',
      200: '#8FB4FF',
      light: '#4D8AF0',
      400: '#1E60CC',
      main: '#002C84',
      dark: '#00226A',
      700: '#001B54',
      darker: '#001340',
      900: '#000A24',
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#FEF2F2',
      light: '#FCA5A5',
      main: '#EF4444',
      dark: '#B91C1C',
      darker: '#7F1D1D',
      contrastText
    },
    warning: {
      lighter: '#FFFBEB',
      light: '#FCD34D',
      main: '#F59E0B',
      dark: '#B45309',
      darker: '#78350F',
      contrastText: greyColors[100]
    },
    info: {
      lighter: '#EFF6FF',
      light: '#93C5FD',
      main: '#3B82F6',
      dark: '#1D4ED8',
      darker: '#1E3A5F',
      contrastText
    },
    success: {
      lighter: '#F0FDF4',
      light: '#86EFAC',
      main: '#22C55E',
      dark: '#15803D',
      darker: '#14532D',
      contrastText
    },
    grey: greyColors
  };
}
